module.exports = __webpack_public_path__ + "img/badge.9d6f2005.svg";